const BOM = '\uFEFF';

const escapeCsv = (value: string | number | undefined | null): string => {
  if (value === null || value === undefined) {
    return '';
  }
  if (typeof value !== 'string') {
    return String(value);
  }
  // カンマ、ダブルクォーテーション、改行が含まれる場合はダブルクォーテーションでエスケープする
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replaceAll('"', '""')}"`;
  }
  // 通常の文字列はそのまま返す
  return value;
};

const downloadAsCsv = (
  data: string | (string | number | undefined | null)[][],
  filename: string,
  options?: { withBom?: boolean }
): void => {
  // データをバイナリ形式に変換し、URLを割り当てる
  const source = Array.isArray(data)
    ? data
        .map((row: (string | number | undefined | null)[]): string => {
          // 各要素をエスケープした後にカンマで結合し、行ごとに改行する
          return row.map(escapeCsv).join(',');
        })
        .join('\n')
    : data;
  const url = window.URL.createObjectURL(
    new Blob(options?.withBom ? [BOM, source] : [source], { type: 'text/csv' })
  );

  // ファイルをダウンロードするための一時的なリンクを作成する
  const element = document.createElement('a');
  element.href = url;
  element.download = filename;
  window.document.body.appendChild(element);

  // 用意したリンクをクリックしてダウンロードを開始する
  element.click();

  // リンクを削除し、URLを解放する
  window.document.body.removeChild(element);
  window.URL.revokeObjectURL(url);
};

const downloadAsJson = (
  data: Record<string, unknown>,
  filename: string
): void => {
  // データをバイナリ形式に変換し、URLを割り当てる
  const source = JSON.stringify(data, null, 2);
  const url = window.URL.createObjectURL(
    new Blob([source], { type: 'application/json' })
  );

  // ファイルをダウンロードするための一時的なリンクを作成する
  const element = document.createElement('a');
  element.href = url;
  element.download = filename;
  window.document.body.appendChild(element);

  // 用意したリンクをクリックしてダウンロードを開始する
  element.click();

  // リンクを削除し、URLを解放する
  window.document.body.removeChild(element);
  window.URL.revokeObjectURL(url);
};

export { downloadAsCsv, downloadAsJson };
